import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { type RefObject } from 'react'
import { type CollectionBuilding } from '../../../../../models/peerToPeer/Collection'
import { SurveyType } from '../../../../../models/SurveySchema'
import {
  STARTSurveyDisplay, START_SURVEY_THEME, type STARTSurveyDisplayHandle
} from '../../../../customComponents/survey/STARTSurveyDisplay'
import { styles } from './BuildingsWithPane.styles'

interface Props {
  building: CollectionBuilding
  lastSavedAt?: string
  surveyRef: RefObject<STARTSurveyDisplayHandle>
  loadForm: () => Promise<{ id: SurveyType, content: string, answers?: string } | null>
  saveForm: (answersJson: string) => Promise<void>
}

export const BuildingFormPanel = ({ building, lastSavedAt, surveyRef, loadForm, saveForm }: Props): JSX.Element => {
  const updatedAt = lastSavedAt ?? building.lastUpdatedAt

  return (
    <Box data-testid='p2pBuildingForm'>
      <Box sx={styles.formHeader}>
        <Typography variant='h3'>{building.name}</Typography>
        {updatedAt != null &&
          <Typography variant='caption' sx={styles.lastUpdated} data-testid='p2pBuildingLastUpdated'>
            Last updated {dayjs(updatedAt).format('MM/DD/YYYY')}
          </Typography>}
      </Box>
      {building.submittedByName != null && building.submittedByName !== '' &&
        <Typography variant='caption' sx={styles.submittedBy} data-testid='p2pBuildingSubmittedBy'>
          Completed by {building.submittedByName}{building.submittedAt != null ? ` · ${dayjs(building.submittedAt).format('MM/DD/YYYY')}` : ''}
        </Typography>}
      <Typography variant='caption' sx={styles.requiredHint}>All fields are required unless marked optional.</Typography>
      <STARTSurveyDisplay
        ref={surveyRef}
        annualPlanId={0}
        planOrgId={0}
        surveyType={SurveyType.PeerToPeer}
        readOnly={building.isLocked}
        hideNavigation
        loadOverride={loadForm}
        saveOverride={saveForm}
        surveyThemeVariables={START_SURVEY_THEME}
      />
    </Box>
  )
}
